import ImpactsOnStakeholdersManagement from './ImpactsOnStakeholdersManagement';

export default ImpactsOnStakeholdersManagement;
